// extracted by mini-css-extract-plugin
export default {"main":"stepsBlock_main__x0AkP"};